import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { List, Form, Button } from 'semantic-ui-react'

//utils
import queries from '../../../../src/utils/queries'

import TitDer from '../../../components/funcionales/titder';

class ConfSimFlujo2 extends React.Component {
  state={argsDocum: {viscosidad:0, diametro:0}
  }

  handleChange = async (ev)=>{
    ev.preventDefault()

    const argsDocum = this.state.argsDocum
    argsDocum[ev.target.name] = ev.target.value

    this.setState({argsDocum});
  }

  handleSubmit = async (ev)=>{
    let argsDocum = this.state.argsDocum

    let viscosidad = argsDocum.viscosidad
    let diametro = argsDocum.diametro
    let flujo = 0

    if(parseFloat(viscosidad)>0 && parseFloat(diametro)>0){
      document.body.style.cursor = 'default'

      flujo = parseInt((viscosidad*diametro*4000)/3162.2)
    }else{
      alert("DEBE DIGITAR LOS 2 VALORES")
    } 
      
    
    let viscosidadTit = 'Viscosidad cinemática (V)'
    let diametroTit = 'Diámetro interior de la tubería (Pulg.)'
    let flujoTit = 'Caudal total de aceite movido por la bomba, gpm'

    document.getElementById('lbMensajeVisTit').innerHTML = viscosidadTit
    let lbMensajeVisTit = document.getElementById('lbMensajeVisTit').innerHTML
    document.getElementById('lbMensajeDiamTit').innerHTML = diametroTit
    let lbMensajeDiamTit = document.getElementById('lbMensajeDiamTit').innerHTML
    document.getElementById('lbMensajeFlujoTit').innerHTML = flujoTit
    let lbMensajeFlujoTit = document.getElementById('lbMensajeFlujoTit').innerHTML
    
    document.getElementById('lbMensajeVis').innerHTML = viscosidad
    let lbMensajeVis = document.getElementById('lbMensajeVis').innerHTML
    document.getElementById('lbMensajeDiam').innerHTML = diametro
    let lbMensajeDiam = document.getElementById('lbMensajeDiam').innerHTML
    document.getElementById('lbMensajeFlujo').innerHTML = flujo
    let lbMensajeFlujo = document.getElementById('lbMensajeFlujo').innerHTML

  }

  

  render(){
    // const {listAp} = this.state;

    return (

      <div>
        <List selection>
          {/* <TitDer list={list} textBoton1="Empresas" btnNuevo={a010101!==-1?"SI":"NO"} styles={styles} handleClick={handleClick} /> */}
          <TitDer textBoton1="Simulador de Flushing Hidráulico " btnNuevo={"NO"} styles={this.props.styles}/>

          {/* <div> */}
          <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
            <Form name="form1" id="form1" onSubmit={(ev)=>this.handleSubmit(ev)}>   
              {/* <label style={{color: 'red'}}>DIGITAR LOS 2 VALORES CONOCIDOS Y DEJAR EN CERO LA VARIABLE QUE DESEA CALCULAR</label>
              <p></p> */}
              <div className="ui two column stackable grid">
                <div className="row container">
                  <div className="column" style={{width: '50%', paddingTop: '0.4em'}}>
                    <Form.Field>
                      <label style={{color: '#000046'}}>Viscosidad cinemática (V)</label>
                      <input type='number' step="0.001" min="0" autoComplete="off" name="viscosidad" id="viscosidad" onChange={this.handleChange}/>
                    </Form.Field>
                  </div>
                  <div className="column" style={{width: '50%', paddingTop: '0.4em'}}>
                    <Form.Field>
                      <label style={{color: '#000046'}}>Diámetro interior de la tubería (Pulg.)</label>
                      <input type='number' step="0.001" min="0" autoComplete="off" name="diametro" id="diametro" onChange={this.handleChange}/>
                    </Form.Field>
                  </div>
                </div>
              </div>
              <p></p>
              <div className="ui one column stackable grid">
                <div className="row container">
                  <div className="column" style={{width: '100%'}}>
                  <Button style={this.props.styles.confirmar} type='submit' fluid>
                    Ver valores de Flushing hidráulico
                  </Button>
                  </div>
                </div>
              </div>
              <p></p>
              <hr></hr>

              <div className="ui two column stackable grid">
                <div className="row container">
                  <div className="column" style={{width: '33%'}}>
                    <Form.Field>
                      <Button style={this.props.styles.titLabel} id="lbMensajeVisTit" type='button' fluid></Button>
                      <Button style={this.props.styles.titLabel2} id="lbMensajeVis" type='button' fluid></Button>
                    </Form.Field>
                  </div>
                  <div className="column" style={{width: '33%'}}>
                    <Form.Field>
                      <Button style={this.props.styles.titLabel} id="lbMensajeDiamTit" type='button' fluid></Button>
                      <Button style={this.props.styles.titLabel2} id="lbMensajeDiam" type='button' fluid></Button>
                    </Form.Field>
                  </div>
                  <div className="column" style={{width: '34%'}}>
                    <Form.Field>
                      <Button style={this.props.styles.titLabel} id="lbMensajeFlujoTit" type='button' fluid></Button>
                      <Button style={this.props.styles.titLabel2} id="lbMensajeFlujo" type='button' fluid></Button>
                    </Form.Field>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </List>
      </div>
    )
  }
};

export default compose( 
  // graphql(queries.query.allPlantaRtes, {name:'allPlantaRtes2',
  //   options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}]`}}}}),
  // graphql(queries.mutation.editPlantaEstructura, {name:'editPlantaEstructura'}),
)(ConfSimFlujo2)
